import { useEffect } from 'react'
import { useInstantSearch } from 'react-instantsearch'

type Props = {
  initialIndexUiState?: Record<string, unknown>
}

export const FiltersUpdate = ({ initialIndexUiState }: Props) => {
  const { setIndexUiState, indexUiState } = useInstantSearch()

  useEffect(() => {
    if (!indexUiState || !setIndexUiState) return undefined

    const timeout = setTimeout(() => {
      setIndexUiState(prev => ({ ...prev, ...initialIndexUiState }))
    }, 1000)

    return () => {
      clearTimeout(timeout)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setIndexUiState])

  return null
}
